import { render, staticRenderFns } from "./ReportWorkloadPage.vue?vue&type=template&id=464d8e60&scoped=true&"
import script from "./ReportWorkloadPage.vue?vue&type=script&lang=js&"
export * from "./ReportWorkloadPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "464d8e60",
  null
  
)

export default component.exports